import { useTranslation } from 'react-i18next';
import { FileSearch, ShieldCheck, XCircle } from 'lucide-react';

type RequestStateValueProps = {
  value?: string;
};

export function RequestStateValue(props: RequestStateValueProps) {
  const { value } = props;
  const { t } = useTranslation();

  return value === 'rejected' ? (
    <>
      <XCircle className="h-5 w-5 text-red-600" />

      <span className="m-2">{t('rejected')}</span>
    </>
  ) : value === 'approved' ? (
    <>
      <ShieldCheck className="h-5 w-5 text-green-700" />
      <span className="m-2">{t('approved')}</span>
    </>
  ) : (
    <>
      <FileSearch className="h-5 w-5 text-cyan-600" />
      <span className="m-2">{t('pending')}</span>
    </>
  );
}
